import { Outlet, ScrollRestoration } from "react-router-dom"
import { SiteHeader } from "./site-header"

export const AppLayout = () => {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <SiteHeader />
      <main className="flex flex-1 flex-col">
        <Outlet />
        <ScrollRestoration />
      </main>
    </div>
  )
}
